export const checkEmailIsValid = (emailInput: string) =>
    /^[ÆØÅæøåA-Za-z0-9._%+-]+@(?:[ÆØÅæøåA-Za-z0-9-]+\.)+[A-Za-z]{2,6}$/.test(emailInput);
